import React from 'react'
import { Button } from '@atd/rui-base.mui.button'
import { Dialog } from '@atd/rui-base.mui.dialog'
import { DialogActions } from '@atd/rui-base.mui.dialog-actions'
import { DialogContent } from '@atd/rui-base.mui.dialog-content'

class DeleteButtonWithDialog extends React.Component {
    static defaultProps = {
        deleteFunction: () => {}, // called on delete put your handler here
        itemType: '', // used in verification text
        customContent: null, // override default verification
        primary: false, // color options. default black, true -> blue, takes priority over secondary
        secondary: false, // color options. default black, true -> grey
        disabled: false, // disable the button
        flat: true, // specify button styling. default flat, false -> raised
    }
    constructor(props) {
        super(props)
        this.state = {
            deleteDialogOpen: false,
        }
    }

    handleDeleteRequest = () => {
        this.setState({ deleteDialogOpen: true })
    }
    handleDelete = () => {
        this.props.deleteFunction()
        this.setState({ deleteDialogOpen: false })
    }
    handleCancel = () => {
        this.setState({ deleteDialogOpen: false })
    }

    renderContent = () => {
        if (this.props.customContent) {
            return this.props.customContent
        }

        return `Are you sure you wish to delete this ${this.props.itemType}?`
    }
    renderDialog = () => {
        const deleteActions = [
            <Button variant="text"
                key="cancelDelete"
                color="primary"
                onClick={this.handleCancel}
                name="cancelDelete">Cancel</Button>,
            <Button variant="text"
                key="confirmDelete"
                color="error"
                startIcon={<img className="standardIcon" src={`${process.env.PUBLIC_URL}/images/jobIcons/Job_DeleteRed.svg`}/>}
                onClick={this.handleDelete}
                name="confirmDelete">Delete</Button>,
        ]
        const content = this.renderContent()

        return (
            <Dialog
                open={this.state.deleteDialogOpen}
                onClose={this.handleCancel}
            >
                <DialogContent>{content}</DialogContent>
                <DialogActions>{deleteActions}</DialogActions>
            </Dialog>
        )
    }

    getDeleteIcon = () => {
        let color = 'White'
        if (this.props.disabled) {
            color = 'Disabled'
        }
        else if (this.props.primary && this.props.flat) {
            color = 'Blue'
        }
        else if (!this.props.primary && !this.props.secondary) {
            color = 'Black'
        }
        else if (this.props.secondary && this.props.flat) {
            // A dark grey would be a closer match
            color = 'Black'
        }

        return <img className="standardIcon" src={`${process.env.PUBLIC_URL}/images/jobIcons/Job_Delete${color}.svg`}/>
    }

    getButton = () => {
        let color = 'inherit'
        if (this.props.primary) color = 'primary'
        else if (this.props.secondary) color = 'secondary'

        if (this.props.flat) {
            return (
                <Button variant="text"
                    startIcon={this.getDeleteIcon()}
                    color={color}
                    onClick={this.handleDeleteRequest}
                    name={`delete${this.props.itemType}`}
                    disabled={this.props.disabled}><span className="btnLabel">Delete</span></Button>
            )
        }

        return (
            <Button variant="contained"
                startIcon={this.getDeleteIcon()}
                color={color}
                onClick={this.handleDeleteRequest}
                name={`delete${this.props.itemType}`}
                disabled={this.props.disabled}>Delete</Button>
        )
    }

    render() {
        const button = this.getButton()
        const dialog = this.renderDialog()

        return (
            <>
                {button}
                {dialog}
            </>
        )
    }
}
export default DeleteButtonWithDialog
